import { render } from "./inpatient_list.vue?vue&type=template&id=50672068&scoped=true"
import script from "./inpatient_list.vue?vue&type=script&lang=js"
export * from "./inpatient_list.vue?vue&type=script&lang=js"

import "./inpatient_list.vue?vue&type=style&index=0&id=50672068&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50672068"]])

export default __exports__